module.exports = __webpack_public_path__ + "static/media/mc.059733fa.svg";